module.exports = {
  "require": (function(x5) {
    return {
      "react-router": require("react-router"),
      "react-dom": require("react-dom"),
      "react-intl/locale-data/cs": require("react-intl/locale-data/cs"),
      "com/fiftyforms/cardweb/components/ff-logo@3x.png": require("com/fiftyforms/cardweb/components/ff-logo@3x.png"),
      "history": require("history"),
      "redux-thunk": require("redux-thunk"),
      "react-beautiful-dnd": require("react-beautiful-dnd"),
      "react": require("react"),
      "react-intl": require("react-intl"),
      "semantic-ui-calendar-react": require("semantic-ui-calendar-react"),
      "draft-js": require("draft-js"),
      "react-intl/locale-data/en": require("react-intl/locale-data/en"),
      "moment-timezone": require("moment-timezone"),
      "react-dropzone": require("react-dropzone"),
      "com/fiftyforms/cardweb/cardui/auth/l10n/cs-CZ.json": require("com/fiftyforms/cardweb/cardui/auth/l10n/cs-CZ.json"),
      "debug": require("debug"),
      "com/fiftyforms/cardweb/cardui/components/card/placeholder.png": require("com/fiftyforms/cardweb/cardui/components/card/placeholder.png"),
      "react-redux": require("react-redux"),
      "downloadjs": require("downloadjs"),
      "semantic-ui-react": require("semantic-ui-react"),
      "redux": require("redux"),
      "react-router-redux": require("react-router-redux"),
      "com/fiftyforms/cardweb/cardui/app/l10n/cs-CZ.json": require("com/fiftyforms/cardweb/cardui/app/l10n/cs-CZ.json")
    }[x5]
  })
}